/* eslint-disable max-lines-per-function */

import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import {
  type Arbeitstage,
  arbeitstage,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { mapArbeitstageSoll } from '@/domain/mitarbeiter/features/anlageassistent/utils/mapArbeitstageSoll';

import {
  Body,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ArbeitstageSelect({
  disableOptionFlexibel = false,
}: {
  disableOptionFlexibel?: boolean;
}) {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  const arbeitstageSelected =
    form.state.values.bezahlung.arbeitszeitkonto.arbeitstage.length > 0;

  const options = Object.keys(arbeitstage);
  const isOptionDisabled = (key: string) =>
    disableOptionFlexibel && key === 'FLEXIBEL';

  return (
    <div className="grid md:grid-cols-2">
      <div className="flex flex-col gap-1">
        <form.AppField
          name="abwesenheiten.allgemein.anzahlArbeitstage"
          defaultValue={
            arbeitstageSelected
              ? mapArbeitstageSoll(
                  form.state.values.bezahlung.arbeitszeitkonto.arbeitstage,
                )
              : undefined
          }>
          {(field) => (
            <FieldBase
              label={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.label',
              )}
              isRequired>
              <Select
                disabled={arbeitstageSelected}
                value={
                  arbeitstageSelected
                    ? mapArbeitstageSoll(
                        form.state.values.bezahlung.arbeitszeitkonto
                          .arbeitstage,
                      )
                    : (field.state.value ?? undefined)
                }
                onValueChange={(value) =>
                  field.handleChange(value as keyof Arbeitstage)
                }>
                <SelectTrigger>
                  <SelectValue
                    onBlur={field.handleBlur}
                    placeholder={t(
                      'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.placeholder',
                    )}
                  />
                </SelectTrigger>
                <SelectContent>
                  {options.map((key) => (
                    <SelectItem
                      key={key}
                      value={key}
                      disabled={isOptionDisabled(key)}>
                      {t(
                        `domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.options.${key}`,
                      )}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FieldBase>
          )}
        </form.AppField>
        {arbeitstageSelected && (
          <Body size={'sm'} className="text-neutrals-700">
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.notEditableDescription',
            )}
          </Body>
        )}
      </div>
    </div>
  );
}
